import Form from "./form/Form";
import Canvas from "./Canvas";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const CanvasHolder = styled.div`
  width: 100%;
  @media screen and (min-width: 1200px) {
    width: 84%;
  }
`;

const FormHolder = styled.div`
  width: 15%;
  display: none;
  @media screen and (min-width: 1200px) {
    display: block;
  }
`;

const WallControl = ({
  yurtTrait,
  wallNumber,
  trait,
  handleTraitChange,
  setWalls,
  walls,
}) => {
  return (
    <Container>
      <FormHolder>
        <Form
          handleTraitChange={handleTraitChange}
          trait={trait}
          yurtTrait={yurtTrait}
        />
      </FormHolder>
      <CanvasHolder>
        <Canvas
          trait={trait}
          yurtTrait={yurtTrait}
          handleTraitChange={handleTraitChange}
          setWalls={setWalls}
          walls={walls}
        />
      </CanvasHolder>
    </Container>
  );
};

export default WallControl;
